import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useMemo, useState } from 'react';

import Formsy from 'formsy-react';
import { kebabCase, omit } from 'lodash';
import { Plus, Trash } from 'lucide-react';
import { toJS } from 'mobx';
import Moment from 'moment-timezone';
import { FormBody, Row, Col, Button, Label, FormGroup, SelectMulti, FormSectionCollapsible, DefaultPopover, Separator, FormFooter, Select, FormCard, ButtonIcon } from 'twyne-new.ui'

import FileUpload from '@/components/FileUpload';
import { useGlobalStore } from '@Stores/global';
import CustomFields from 'components/custom_fields/CustomFields';
import DateTimePicker from 'components/form/DateTimePicker';
import HTMLEditorPreview from 'components/form/HTMLEditorPreview';
import Input from 'components/form/Input';
import SelectAsync from 'components/form/SelectAsync';
import Switch from 'components/form/Switch';
import tagStore from 'modules/cms/stores/tag';
import formStore from 'modules/offer/stores/form';
import appStore from 'stores/app';
import history from 'utils/history';

import { usePostStore } from '../store';

import SelectForm from './SelectForm'
import SweepOptions from './SweepOptions';

class PostForm extends React.Component {
  state = {
    flight_start_at: null,
    flight_end_at: null,
    flightStartFocused: false,
    flightEndFocused: false,
    active: true,
    site_id: appStore.site.id,
    slugTouch: false,
    tagOptions: [],
    tags: [],
    activeTab: 'options',
    custom: {},
    featured_image: null,
    isLoadImage: false,
  }

  loadTagOptions = () => {
    tagStore.all({ site_id: appStore.site.id, content_type: this.props.contentType }).then(response => {
      const options = response.data.rows.map(tag => ({ label: tag.name, value: tag.id }));
      this.setState({ tagOptions: options });
    });
  }

  loadFormOptions = async () => {
    const update = { formOptions: [], mobileFormOptions: [] }
    const { data: forms } = await formStore.all()

    forms.forEach(form => {
      const { allowed_on, device_type } = form

      if (allowed_on === null || allowed_on.includes('pages')) {
        const option = { value: form.id, label: form.name, steps: form.step }

        if (device_type === null || device_type.includes('desktop')) {
          update.formOptions.push(option)

          if (this.state.form_id === form.id) {
            update.formConversionStepsOptions = [...Array(option.steps || 0)].map((_, index) => ({ value: index + 1, label: index + 1 }))
          }
        }

        if (device_type === null || device_type.includes('mobile')) {
          update.mobileFormOptions.push(option)

          if (this.state.mobile_form_id === form.id) {
            update.mobileConversionStepsOptions = [...Array(option.steps || 0)].map((_, index) => ({ value: index + 1, label: index + 1 }))
          }
        }
      }
    })

    this.setState(update)
  }

  parseData(data) {
    data = toJS(data);
    if (data) {
      if (data.custom && typeof data.custom == "string") {
        data.custom = JSON.parse(data.custom);
      }

      data.tags = data.tags.map(tag => ({ label: tag.name, value: tag.id }));
      data.flight_end_at = data.flight_end_at ? Moment(data.flight_end_at).tz(appStore.timezone) : null
      data.flight_start_at = data.flight_start_at ? Moment(data.flight_start_at).tz(appStore.timezone) : null
      this.setState(data);
    }
  }

  componentWillMount() {
    this.parseData(this.props.data)
    this.loadTagOptions();
    this.loadFormOptions();
  }

  handleTagsChange = values => {
    this.setState({ tags: values });
  }

  handleToggleFormChange = value => {
    const update = { toggleForm: value }
    if (!value) update.forms = null
    this.setState(update)
  }

  handleValidSubmit = model => {
    model.content_type = this.props.contentType;
    const data = omit(this.state, OMIT)
    data.flight_start_at = data.flight_start_at !== null ? data.flight_start_at.format() : null
    data.flight_end_at = data.flight_end_at !== null ? data.flight_end_at.format() : null
    data.tags = data.tags.map(tag => tag.value);
    data.custom = JSON.stringify(data.custom);

    // filter only touched meta tags
    data.meta_tag = (data.meta_tag || []).filter(o => o.touch == true)

    this.props.handleSubmit(Object.assign(data, model));
  }

  handleCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    } else {
      history.goBack();
    }
  }

  onChangeTitle = event => {
    const { value } = event.currentTarget;
    if (!this.state.id && !this.state.slugTouch) {
      this.setState({
        slug: kebabCase(value),
      });
    }
    this.props.onChangeTitle(value);
  }

  onChangeSlug = event => {
    const { value } = event.currentTarget;
    if (value && value.length) {
      this.setState({
        slug: value,
        slugTouch: true,
      })
    } else {
      this.setState({
        slugTouch: false,
      })
    }
  }

  useThemeConfig = path => {
    const { siteSettings: { getThemeConfig } } = useGlobalStore()
    return getThemeConfig(path)
  }

  useSweepConfirmationModule = () => {
    const templates = this.useThemeConfig(`modules.sweeps.templates`) || []

    if (!Array.isArray(templates)) return false

    const hasConfirm = templates.some(template => template.includes('s-confirm'))
    const hasRegister = templates.some(template => template.includes('s-register'))

    return hasConfirm && hasRegister || false
  }

  handleCustomChange = (key, value) => {
    const custom = { ...this.state.custom };
    custom[key] = value;
    this.setState({ custom });
  };

  getSweepCycles = () => {
    if (!this.state.sweep) {
      return null
    }

    const { sweepCycles } = this.state.sweep
    if (!sweepCycles || !sweepCycles.length) {
      return null
    }

    return this.sweepCycles = this.sweepCycles || sweepCycles.map(cycle => {
      cycle.startsAt = Moment.utc(cycle.startsAt).format('x')
      cycle.endsAt = Moment.utc(cycle.endsAt).format('x')
      return cycle
    })
  }

  handleImageRemove = () => this.setState({ featured_image: null })

  Flight = ({ id, value, onChange }) => {
    const { collection: { data } } = usePostStore()
    const disabled = data && data.versionId ? true : false

    const handleDayBlocked = day => {
      const sweepCycles = this.getSweepCycles()
      if (!sweepCycles) {
        return false
      }

      return sweepCycles.some(cycle => day.format('x') > cycle.startsAt && day.format('x') < cycle.endsAt)
    }

    const handleChange = value => {
      this.setState({ [id]: value })
      value && onChange && onChange(value)
    }

    return <DateTimePicker meridiemSystem checkbox name={id}
      disabled={disabled}
      value={value}
      onChange={handleChange}
      openDirection="down"
      isDayHighlighted={handleDayBlocked}
      isDayBlocked={() => false}
      isOutsideRange={() => false}
      mask='MM/DD/YYYY'
    />
  }

  Group = ({ children, ...props }) => <Col {...props}>
    <FormGroup>
      {children}
    </FormGroup>
  </Col>

  Content = () => {
    const hideContent = this.useThemeConfig(`types.${this.props.contentType}.post.hideContent`)

    if (hideContent) {
      return null
    }

    const { content } = this.state

    return <Col size="12">
      <HTMLEditorPreview name="content" value={content} />
    </Col>
  }

  CustomFields = () => {
    const hasCustomFields = this.useThemeConfig(`types.${this.props.contentType}.post.custom`)

    if (!hasCustomFields) {
      return null
    }

    const { template, slug, custom } = this.state

    return <FormCard title='Custom Fields'>
      <CustomFields
        config={hasCustomFields}
        onChange={this.handleCustomChange}
        custom={custom}
        extra={{
          slug, template,
          content_type: this.props.contentType,
        }}
      />
    </FormCard >
  }

  PostOptions = () => {
    const { collection: { data }, uploadImage, templates: { getTemplates }, lists: { rewards: { useLoad: useLoadRewards, items: rewards } } } = usePostStore()
    const { featured_image, isLoadImage, tagOptions, tags, slug, template, rewardId } = this.state
    const { contentType } = this.props
    const disabled = data && data.versionId ? true : false

    const params = useMemo(() => ({ type: ['points', 'deals_only'] }), [])
    useLoadRewards(params)

    const loadOptions = useCallback(async () => await getTemplates()(contentType), [getTemplates, contentType])
    const rewardsOptions = useMemo(() => rewards.map(({ id, name }) => ({ value: id, label: `[#${id}] - ${name}` })), [rewards])

    const handleImageUpload = useCallback(file => {
      this.setState({ isLoadImage: true }, () => {
        uploadImage(file)
          .then(file => this.setState({ featured_image: file.location }))
          .catch(response => this.handleImageRemove())
          .finally(response => this.setState({ isLoadImage: false }))
      })
    }, [uploadImage])

    return <Col>
      <FormCard title='Details'>
        <Row>
          <this.Group size="12">
            <Label>Featured Image</Label>
            <FileUpload
              onUpload={handleImageUpload}
              value={featured_image}
              isLoading={isLoadImage}
              onRemove={this.handleImageRemove}
            />
          </this.Group>
          <this.Group size="12">
            <Label>Categories</Label>
            <SelectMulti
              disabled={disabled}
              closeOnSelect={false}
              multi
              options={tagOptions}
              value={tags}
              onChange={this.handleTagsChange}
            />
          </this.Group>
          <this.Group size="12">
            <Label>Slug</Label>
            <Input name="slug" value={slug || ''} onChange={this.onChangeSlug} disabled={disabled} required />
          </this.Group>
          <this.Group size="12">
            <Label>Reward</Label>
            <Select name="rewardId" value={rewardId || ''} options={rewardsOptions} disabled={disabled} onChange={reward => this.setState({ rewardId: reward?.value || null })} />
          </this.Group>
          <this.Group size="12">
            <Label>Template</Label>
            <SelectAsync name="template" value={template || ""} loadOptions={loadOptions} onChange={template => this.setState({ template })} />
          </this.Group>
        </Row>
      </FormCard>
    </Col>
  }

  FormOptions = () => {
    const { toggleForm, forms, formOptions, mobileFormOptions } = this.state
    const { contentType } = this.props
    const { desktop } = forms || {}

    useEffect(() => {
      if (desktop?.length) {
        this.setState({ toggleForm: true })
      }
    }, [desktop])

    return <Col>
      <FormCard
        title='Form options'
        render={!!toggleForm}
        headerButtons={<div className='flex items-center gap-2'>
          <Switch
            name="_"
            value={toggleForm || false}
            setValue={this.handleToggleFormChange}
          />
          <Label>Active</Label>
        </div>}>
        <Row>
          <Col size='12'>
            <SelectForm required forms={forms} onChange={forms => this.setState({ forms })}
              formOptions={formOptions} mobileFormOptions={mobileFormOptions} origin={contentType} />
          </Col>
        </Row>
      </FormCard>
    </Col>
  }

  PageOptions = () => {
    const { collection: { data } } = usePostStore()
    const { flight_end_at, flight_start_at, active, restricted } = this.state
    const disabled = data && data.versionId ? true : false

    return <>
      <Col>
        <FormCard title='Page Options'>
          <Row>
            <Col size='6' className='flex items-center gap-2'>
              <Switch name="active" value={active || false} setValue={active => this.setState({ active })} />
              <Label>Active</Label>
            </Col>
            <Col size='6' className='flex items-center gap-2'>
              <Switch name="restricted" value={restricted || false} disabled={disabled} />
              <Label>Restricted</Label>
            </Col>
            <Col size='12'>
              <Row>
                <this.Group size='6'>
                  <Label>Flight Starts at</Label>
                  <this.Flight id='flight_start_at' value={flight_start_at} onChange={date => date.startOf('day')} />
                </this.Group>
                <this.Group size='6'>
                  <Label>Flight Ends at</Label>
                  <this.Flight id='flight_end_at' value={flight_end_at} onChange={date => date.endOf('day').milliseconds(0)} />
                </this.Group>
              </Row>
            </Col>
          </Row>
        </FormCard>
      </Col>
    </>
  }

  handleMetaTags = (key, value) => {
    const meta_tag = this.state.meta_tag || [];
    const idx = meta_tag.findIndex(obj => obj.key == key)

    if (idx < 0) {
      return
    }

    meta_tag[idx].value = value;
    meta_tag[idx].touch = true;

    this.setState({ meta_tag });
  };

  handleCreateTag = data => {
    const meta_tag = this.state.meta_tag || [];

    const idx = meta_tag.findIndex(obj => obj.key == data.key)
    if (idx >= 0) {
      return false
    }

    meta_tag.push(data)
    this.setState({ meta_tag })

    return true
  }

  handleDeleteResetTag = key => {
    let { meta_tag } = this.state
    meta_tag = meta_tag.filter(c => c.key !== key)
    this.setState({ meta_tag })
  }

  checkMetaTagExist = key => (this.state.meta_tag || []).findIndex(obj => obj.key == key) >= 0

  useSystemMetaTag = key => {
    const { siteSettings: { useSystemConfig } } = useGlobalStore()
    const metaTags = useSystemConfig(`metatag`)
    return useMemo(() => (metaTags || []).findIndex(o => o.override === true && o.key === key) >= 0, [key, metaTags])
  }

  MetaTags = () => {
    const { meta_tag } = this.state
    const { siteSettings: { useSystemConfig } } = useGlobalStore()

    const metatags = useSystemConfig('metatag')
    useEffect(() => {
      const systemMetaTags = (metatags || []).filter(o => o.override === true)
      const currentMetaTags = meta_tag || []

      currentMetaTags.push(...systemMetaTags.filter(smt => !currentMetaTags.some(cmt => cmt.key === smt.key)))
      this.setState({ meta_tag: currentMetaTags })
    }, [metatags, meta_tag])

    return <>
      <Col>
        <FormCard title='Meta Tags' headerButtons={<>
          <AddMetaTagPopover onSubmit={this.handleCreateTag} checkMetaExists={this.checkMetaTagExist} >
            <Button color='accent' size='sm'>
              <Plus size={14} />
              Add
            </Button>
          </AddMetaTagPopover>
        </>}>
          {meta_tag?.length ? <>
            <Row>
              {meta_tag?.map(({ key, value }) => <this.MetaTag key={key} name={key} value={value} />)}
            </Row>
          </> : null}
        </FormCard>
      </Col>
    </>
  }

  MetaTag = ({ name, value }) => {
    const isSystemMetaTag = this.useSystemMetaTag(name)

    const handleClick = () => this.handleDeleteResetTag(name)
    const handleChange = evt => this.handleMetaTags(name, evt.currentTarget.value)

    return <this.Group size='12' >
      <div className='flex justify-between items-center'>
        <Label>
          {name}
        </Label>
        {!isSystemMetaTag && <ButtonIcon content='Delete' onClick={handleClick}>
          <Trash size={16} />
        </ButtonIcon>}
      </div>
      <Input name={`meta_${name}`} value={value} onChange={handleChange} />
    </this.Group>
  }

  SweepOptions = () => {
    const { collection: { data } } = usePostStore()
    const { active, flight_end_at, flight_start_at, id, sweep } = this.state
    const hasConfirmation = this.useSweepConfirmationModule()
    const disabled = data && data.versionId ? true : false

    if (this.props.contentType !== 'sweep') {
      return null
    }

    return <>
      <Col>
        <FormSectionCollapsible
          border
          title='Sweeps options'
          collapsible={!!id}
          triggerClass='py-3 px-4'
          className='shadow rounde twy-bg-base-accent border-0!'
          contentClass='p-4'
        >
          <SweepOptions
            disabled={disabled}
            data={sweep || {}}
            hasConfirmation={hasConfirmation}
            sweepCycles={this.getSweepCycles()}
            postOpts={{ active, startsAt: flight_start_at, endsAt: flight_end_at, id }}
            onChange={values => {
              this.setState(({ sweep }) => ({ sweep: { ...sweep, ...values } }))
            }}
          />
        </FormSectionCollapsible>
      </Col>
    </>
  }

  render() {
    const { title } = this.state

    return <Formsy onValidSubmit={this.handleValidSubmit}>
      <FormBody>
        <Row>
          <Col size="9">
            <Row>
              <Col>
                <FormCard title='General'>
                  <Row>
                    <this.Group size="12">
                      <Label>Title</Label>
                      <Input name="title" value={title || ''} onChange={this.onChangeTitle} required />
                    </this.Group>
                    <this.Content />
                  </Row>
                </FormCard>
              </Col>
              <Col>
                <this.CustomFields />
              </Col>
            </Row>
          </Col>
          <Col size="3">
            <Row>
              <this.PostOptions />
              <this.PageOptions />
              <this.SweepOptions />
              <this.MetaTags />
              <this.FormOptions />
            </Row>
          </Col>
        </Row>
        <FormFooter>
          <Button type="submit" color="accent">Save</Button>
          <Button onClick={this.handleCancel} variant='ghost'>Cancel</Button>
        </FormFooter>
      </FormBody>
    </Formsy>
  }
}

function AddMetaTagPopover({ onSubmit, checkMetaExists, children }) {
  const [open, setOpen] = useState(false)
  const [key, setKey] = useState('')
  const [disabled, setDisabled] = useState(true)
  const [showExistWarning, setShowExistWarning] = useState(false)
  const toggle = () => setOpen(!open)

  const handleSubmit = () => {
    onSubmit({ key })
    setOpen(false)
  }

  const handleKeyChange = value => {
    if (!value) {
      return setDisabled(true)
    }

    const exists = checkMetaExists(value)

    setDisabled(!value || exists)
    setShowExistWarning(exists)

    value = value.toLocaleLowerCase()

    setKey(kebabCase(value));
  }

  return <DefaultPopover trigger={children} wrapperProps={{ open, onOpenChange: toggle }} >
    Create Meta Tag
    <Separator className='m-0 my-2' />
    <FormGroup className='pt-2'>
      <Label>Key</Label>
      <Input required name='key' onChange={e => handleKeyChange(e.currentTarget.value)} />
      {showExistWarning && <span className="twy-text-danger">this key already exists</span>}
    </FormGroup>
    <div className='flex gap-2 mt-4'>
      <Button block color='accent' size='sm' disabled={disabled} onClick={handleSubmit}>Add</Button>
      <Button block size='sm' onClick={() => setOpen(false)} variant='ghost'>Cancel</Button>
    </div>
  </DefaultPopover>
}

const OMIT = [
  "activeTab",
  "flightEndFocused",
  "flightStartFocused",
  "formOptions",
  "isLoadImage",
  "mobileFormOptions",
  "optins",
  "optins_daily",
  "optins_monthly",
  "optins_resetat",
  "optins_updateat",
  "optins_weekly",
  "slugTouch",
  "tagOptions",
  "versions",
  "views",
  "_",
]

PostForm.propTypes = {
  handleSubmit: PropTypes.func,
  onChangeTitle: PropTypes.func,
  data: PropTypes.any,
  contentType: PropTypes.string,
};

export default PostForm;
